import { RootState } from "store/store";
import { StateFn } from "store/types";

import { DocumentsState } from "./documentsStore";
import { DocumentCategory } from "./types";

const getStore = (state: RootState): DocumentsState => state.documents;

const category: StateFn<DocumentCategory | null> = (state: RootState) =>
  getStore(state).category;

export const documentsSelectors = {
  category,
};
